// @generated by protobuf-ts 2.11.1 with parameter generate_dependencies,ts_nocheck
// @generated from protobuf file "agency/tool/v1/tool.proto" (package "agency.tool.v1", syntax proto3)
// tslint:disable
// @ts-nocheck
import { ServiceType } from "@protobuf-ts/runtime-rpc";
import type { BinaryWriteOptions } from "@protobuf-ts/runtime";
import type { IBinaryWriter } from "@protobuf-ts/runtime";
import { WireType } from "@protobuf-ts/runtime";
import type { BinaryReadOptions } from "@protobuf-ts/runtime";
import type { IBinaryReader } from "@protobuf-ts/runtime";
import { UnknownFieldHandler } from "@protobuf-ts/runtime";
import type { PartialMessage } from "@protobuf-ts/runtime";
import { reflectionMergePartial } from "@protobuf-ts/runtime";
import { MessageType } from "@protobuf-ts/runtime";
import { Timestamp } from "../../../google/protobuf/timestamp";
import { Struct } from "../../../google/protobuf/struct";
/**
 * ToolCallFrequencyConfig limits tool call frequency per workspace.
 *
 * @generated from protobuf message agency.tool.v1.ToolCallFrequencyConfig
 */
export interface ToolCallFrequencyConfig {
    /**
     * max_calls_per_minute is the maximum calls allowed per tool per workspace.
     *
     * @generated from protobuf field: int32 max_calls_per_minute = 1
     */
    maxCallsPerMinute: number;
    /**
     * sliding_window_seconds is the window size for frequency calculation.
     *
     * @generated from protobuf field: int32 sliding_window_seconds = 2
     */
    slidingWindowSeconds: number;
    /**
     * burst_allowance is additional calls allowed in short bursts.
     *
     * @generated from protobuf field: int32 burst_allowance = 3
     */
    burstAllowance: number;
}
/**
 * ToolDescriptor defines a tool's metadata and schema.
 *
 * @generated from protobuf message agency.tool.v1.ToolDescriptor
 */
export interface ToolDescriptor {
    /**
     * name is the unique tool identifier.
     *
     * @generated from protobuf field: string name = 1
     */
    name: string;
    /**
     * description explains what the tool does (shown to LLM).
     *
     * @generated from protobuf field: string description = 2
     */
    description: string;
    /**
     * tags are categorization labels for discovery.
     *
     * @generated from protobuf field: repeated string tags = 3
     */
    tags: string[];
    /**
     * category is the primary tool category.
     *
     * @generated from protobuf field: string category = 4
     */
    category: string;
    /**
     * input_schema is the JSON Schema for tool arguments.
     *
     * @generated from protobuf field: google.protobuf.Struct input_schema = 5
     */
    inputSchema?: Struct;
    /**
     * exclusive enforces cluster-wide serialized execution.
     *
     * @generated from protobuf field: bool exclusive = 6
     */
    exclusive: boolean;
    /**
     * frequency_limit restricts call frequency per workspace.
     *
     * @generated from protobuf field: agency.tool.v1.ToolCallFrequencyConfig frequency_limit = 7
     */
    frequencyLimit?: ToolCallFrequencyConfig;
    /**
     * estimated_cost_tokens is the approximate token cost for quota pre-check.
     *
     * @generated from protobuf field: int64 estimated_cost_tokens = 8
     */
    estimatedCostTokens: bigint;
    /**
     * timeout_seconds is the maximum execution time.
     *
     * @generated from protobuf field: int32 timeout_seconds = 9
     */
    timeoutSeconds: number;
    /**
     * requires_credentials indicates if the tool needs credentials.
     *
     * @generated from protobuf field: bool requires_credentials = 10
     */
    requiresCredentials: boolean;
    /**
     * version is the tool implementation version.
     *
     * @generated from protobuf field: string version = 11
     */
    version: string;
    /**
     * provider is the backend that implements this tool.
     *
     * @generated from protobuf field: string provider = 12
     */
    provider: string;
    /**
     * credential_key is the credential identifier for CredentialService lookup.
     *
     * @generated from protobuf field: string credential_key = 13
     */
    credentialKey: string;
    /**
     * embedding is the tool's embedding vector for semantic matching.
     *
     * @generated from protobuf field: repeated float embedding = 14
     */
    embedding: number[];
    /**
     * execution_mode is the transport mode for remote dispatch.
     * Set at registration time from ToolRegistrationAck.selected_mode.
     * Required for remote tools — EXECUTION_MODE_UNSPECIFIED means not yet registered.
     *
     * @generated from protobuf field: agency.tool.v1.ExecutionMode execution_mode = 15
     */
    executionMode: ExecutionMode;
    /**
     * process_id identifies the registered tool instance for execution subject
     * routing. Set at registration time from ToolRegistrationRequest.process_id.
     *
     * @generated from protobuf field: string process_id = 16
     */
    processId: string;
    /**
     * location is the provider's free-form location label (e.g. "machine-a", "us-east-1").
     * Set at registration time from ToolRegistrationRequest.location.
     * Restricted to [a-z0-9][a-z0-9_-]*[a-z0-9] — safe as a NATS subject token and KV key component.
     * Empty = location-unaware (single provider per tool name).
     *
     * @generated from protobuf field: string location = 17
     */
    location: string;
}
/**
 * ToolCall represents a tool invocation request from the LLM.
 *
 * @generated from protobuf message agency.tool.v1.ToolCall
 */
export interface ToolCall {
    /**
     * id is the unique tool call identifier.
     *
     * @generated from protobuf field: string id = 1
     */
    id: string;
    /**
     * name is the tool to invoke.
     *
     * @generated from protobuf field: string name = 2
     */
    name: string;
    /**
     * arguments are the tool input parameters (validated against input_schema).
     *
     * @generated from protobuf field: google.protobuf.Struct arguments = 3
     */
    arguments?: Struct;
    /**
     * created_at is when the LLM generated this call.
     *
     * @generated from protobuf field: google.protobuf.Timestamp created_at = 4
     */
    createdAt?: Timestamp;
    /**
     * session_id is the session this call belongs to.
     *
     * @generated from protobuf field: string session_id = 5
     */
    sessionId: string;
    /**
     * turn_id is the turn this call belongs to.
     *
     * @generated from protobuf field: string turn_id = 6
     */
    turnId: string;
    /**
     * nats_msg_id is the NATS message ID for lock key generation.
     *
     * @generated from protobuf field: string nats_msg_id = 7
     */
    natsMsgId: string;
}
/**
 * ToolCredentials contains credentials for tool execution.
 * SECURITY: Never log, persist, or echo in ToolResult.
 * This message is ONLY used in Hollywood messages (ToolDispatchPool → ToolActor), never serialized to NATS.
 *
 * @generated from protobuf message agency.tool.v1.ToolCredentials
 */
export interface ToolCredentials {
    /**
     * secrets maps secret keys to values (api_key, client_secret, token, etc.).
     * Populated from SOPS Provider's memguard-protected cache.
     * CRITICAL: Never serialize to NATS streams or logs.
     *
     * @generated from protobuf field: map<string, string> secrets = 1
     */
    secrets: {
        [key: string]: string;
    };
    /**
     * metadata contains non-secret credential context (provider, workspace_id, endpoint).
     *
     * @generated from protobuf field: map<string, string> metadata = 2
     */
    metadata: {
        [key: string]: string;
    };
    /**
     * expires_at is the credential expiration time (optional).
     *
     * @generated from protobuf field: google.protobuf.Timestamp expires_at = 3
     */
    expiresAt?: Timestamp;
}
/**
 * ToolExecutionEnvelope wraps a tool call with credentials and context.
 * This is the input to Tool.Execute() - never serialized to NATS.
 *
 * @generated from protobuf message agency.tool.v1.ToolExecutionEnvelope
 */
export interface ToolExecutionEnvelope {
    /**
     * call is the tool invocation request.
     *
     * @generated from protobuf field: agency.tool.v1.ToolCall call = 1
     */
    call?: ToolCall;
    /**
     * credentials are the tool credentials (NEVER in NATS streams).
     *
     * @generated from protobuf field: agency.tool.v1.ToolCredentials credentials = 2
     */
    credentials?: ToolCredentials;
    /**
     * tenant is the tenant context.
     *
     * @generated from protobuf field: string tenant = 3
     */
    tenant: string;
    /**
     * workspace is the workspace context.
     *
     * @generated from protobuf field: string workspace = 4
     */
    workspace: string;
    /**
     * trace_id is the OpenTelemetry trace ID.
     *
     * @generated from protobuf field: string trace_id = 5
     */
    traceId: string;
}
/**
 * ToolPartialResult represents streaming tool execution updates.
 *
 * @generated from protobuf message agency.tool.v1.ToolPartialResult
 */
export interface ToolPartialResult {
    /**
     * tenant is the tenant context for subject routing.
     *
     * @generated from protobuf field: string tenant = 1
     */
    tenant: string;
    /**
     * workspace is the workspace context for subject routing.
     *
     * @generated from protobuf field: string workspace = 2
     */
    workspace: string;
    /**
     * session_id is the session context for subject routing.
     *
     * @generated from protobuf field: string session_id = 3
     */
    sessionId: string;
    /**
     * tool_call_id identifies this tool execution for subject routing.
     *
     * @generated from protobuf field: string tool_call_id = 4
     */
    toolCallId: string;
    /**
     * delta is the incremental output since the last partial.
     *
     * @generated from protobuf field: google.protobuf.Struct delta = 5
     */
    delta?: Struct;
    /**
     * accumulated is the full output so far (optional for efficiency).
     *
     * @generated from protobuf field: google.protobuf.Struct accumulated = 6
     */
    accumulated?: Struct;
    /**
     * timestamp is when this partial was generated.
     *
     * @generated from protobuf field: google.protobuf.Timestamp timestamp = 7
     */
    timestamp?: Timestamp;
}
/**
 * ToolResult represents the final tool execution result.
 *
 * @generated from protobuf message agency.tool.v1.ToolResult
 */
export interface ToolResult {
    /**
     * tool_call_id links this result to the originating call.
     *
     * @generated from protobuf field: string tool_call_id = 1
     */
    toolCallId: string;
    /**
     * Payload is either plaintext (trusted intra-cluster) or AGE-encrypted (edge/untrusted).
     *
     * @generated from protobuf oneof: payload
     */
    payload: {
        oneofKind: "plaintext";
        /**
         * plaintext is the unencrypted result.
         *
         * @generated from protobuf field: google.protobuf.Struct plaintext = 2
         */
        plaintext: Struct;
    } | {
        oneofKind: "ageCiphertext";
        /**
         * age_ciphertext is the AGE-encrypted result (for edge nodes).
         *
         * @generated from protobuf field: bytes age_ciphertext = 3
         */
        ageCiphertext: Uint8Array;
    } | {
        oneofKind: "binaryData";
        /**
         * binary_data is non-encrypted binary result (images, files, etc).
         *
         * @generated from protobuf field: bytes binary_data = 10
         */
        binaryData: Uint8Array;
    } | {
        oneofKind: "objectStoreRef";
        /**
         * object_store_ref is a reference to large results stored in Object Store.
         *
         * @generated from protobuf field: string object_store_ref = 11
         */
        objectStoreRef: string;
    } | {
        oneofKind: undefined;
    };
    /**
     * recipient_pubkey_fingerprint provides audit trail without content exposure.
     *
     * @generated from protobuf field: string recipient_pubkey_fingerprint = 4
     */
    recipientPubkeyFingerprint: string;
    /**
     * is_error indicates if the execution failed.
     *
     * @generated from protobuf field: bool is_error = 5
     */
    isError: boolean;
    /**
     * error_message describes the failure (empty if is_error is false).
     *
     * @generated from protobuf field: string error_message = 6
     */
    errorMessage: string;
    /**
     * error_class classifies the error for retry policy.
     *
     * @generated from protobuf field: agency.tool.v1.ErrorClass error_class = 7
     */
    errorClass: ErrorClass;
    /**
     * completed_at is the execution completion timestamp.
     *
     * @generated from protobuf field: google.protobuf.Timestamp completed_at = 8
     */
    completedAt?: Timestamp;
    /**
     * execution_time_ms is the execution duration in milliseconds.
     *
     * @generated from protobuf field: int64 execution_time_ms = 9
     */
    executionTimeMs: bigint;
    /**
     * tokens_consumed is the estimated token cost (for quota tracking).
     *
     * @generated from protobuf field: int64 tokens_consumed = 12
     */
    tokensConsumed: bigint;
    /**
     * tool_name is the name of the tool that produced this result.
     * Set by the harness at dispatch time (not the provider) for use in
     * POST_TOOL_CALL hook ToolFilter evaluation.
     *
     * @generated from protobuf field: string tool_name = 13
     */
    toolName: string;
    /**
     * location is the provider location label of the tool that produced this result.
     * Set by the harness at dispatch time alongside tool_name for POST_TOOL_CALL hook filtering.
     *
     * @generated from protobuf field: string location = 14
     */
    location: string;
}
/**
 * MatchRequest requests tool matching based on criteria.
 *
 * @generated from protobuf message agency.tool.v1.MatchRequest
 */
export interface MatchRequest {
    /**
     * query is the natural language query or description.
     *
     * @generated from protobuf field: string query = 1
     */
    query: string;
    /**
     * tags are required tags for filtering.
     *
     * @generated from protobuf field: repeated string tags = 2
     */
    tags: string[];
    /**
     * categories are required categories for filtering.
     *
     * @generated from protobuf field: repeated string categories = 3
     */
    categories: string[];
    /**
     * top_k is the maximum number of results to return.
     *
     * @generated from protobuf field: int32 top_k = 4
     */
    topK: number;
    /**
     * min_relevance_score is the minimum relevance threshold.
     *
     * @generated from protobuf field: float min_relevance_score = 5
     */
    minRelevanceScore: number;
    /**
     * tenant is the tenant context.
     *
     * @generated from protobuf field: string tenant = 6
     */
    tenant: string;
    /**
     * workspace is the workspace context.
     *
     * @generated from protobuf field: string workspace = 7
     */
    workspace: string;
}
/**
 * MatchResponse returns matched tools.
 *
 * @generated from protobuf message agency.tool.v1.MatchResponse
 */
export interface MatchResponse {
    /**
     * tools are the matched tool descriptors.
     *
     * @generated from protobuf field: repeated agency.tool.v1.ToolDescriptor tools = 1
     */
    tools: ToolDescriptor[];
    /**
     * relevance_scores are the relevance scores for each tool (parallel to tools array).
     *
     * @generated from protobuf field: repeated float relevance_scores = 2
     */
    relevanceScores: number[];
    /**
     * total_matches is the total number of matching tools (before top_k limit).
     *
     * @generated from protobuf field: int32 total_matches = 3
     */
    totalMatches: number;
}
/**
 * ToolDecision represents whether a tool call should proceed.
 * Used by SecurityGateActor and hooks.
 *
 * @generated from protobuf message agency.tool.v1.ToolDecision
 */
export interface ToolDecision {
    /**
     * approved indicates if the tool call is allowed.
     *
     * @generated from protobuf field: bool approved = 1
     */
    approved: boolean;
    /**
     * reason explains the decision.
     *
     * @generated from protobuf field: string reason = 2
     */
    reason: string;
    /**
     * modified_arguments contains sanitized/transformed arguments if approved.
     *
     * @generated from protobuf field: google.protobuf.Struct modified_arguments = 3
     */
    modifiedArguments?: Struct;
    /**
     * hook_name identifies which hook made the decision.
     *
     * @generated from protobuf field: string hook_name = 4
     */
    hookName: string;
    /**
     * decided_at is the decision timestamp.
     *
     * @generated from protobuf field: google.protobuf.Timestamp decided_at = 5
     */
    decidedAt?: Timestamp;
}
/**
 * ToolExecutionLock represents an exclusive tool execution lock.
 *
 * @generated from protobuf message agency.tool.v1.ToolExecutionLock
 */
export interface ToolExecutionLock {
    /**
     * lock_key is the KV lock key (tool-execution-lock.<tenant>.<workspace>.<nats-msg-id>).
     *
     * @generated from protobuf field: string lock_key = 1
     */
    lockKey: string;
    /**
     * tool_name is the exclusive tool being locked.
     *
     * @generated from protobuf field: string tool_name = 2
     */
    toolName: string;
    /**
     * tenant is the tenant identifier.
     *
     * @generated from protobuf field: string tenant = 3
     */
    tenant: string;
    /**
     * workspace is the workspace identifier.
     *
     * @generated from protobuf field: string workspace = 4
     */
    workspace: string;
    /**
     * nats_msg_id is the NATS message ID for this execution.
     *
     * @generated from protobuf field: string nats_msg_id = 5
     */
    natsMsgId: string;
    /**
     * holder_pid is the Hollywood actor PID holding the lock.
     *
     * @generated from protobuf field: string holder_pid = 6
     */
    holderPid: string;
    /**
     * acquired_at is when the lock was acquired.
     *
     * @generated from protobuf field: google.protobuf.Timestamp acquired_at = 7
     */
    acquiredAt?: Timestamp;
    /**
     * expires_at is when the lock expires (TTL).
     *
     * @generated from protobuf field: google.protobuf.Timestamp expires_at = 8
     */
    expiresAt?: Timestamp;
}
/**
 * ToolExecutionLockAcquireRequest requests exclusive lock acquisition.
 *
 * @generated from protobuf message agency.tool.v1.ToolExecutionLockAcquireRequest
 */
export interface ToolExecutionLockAcquireRequest {
    /**
     * tool_name is the exclusive tool to lock.
     *
     * @generated from protobuf field: string tool_name = 1
     */
    toolName: string;
    /**
     * tenant is the tenant identifier.
     *
     * @generated from protobuf field: string tenant = 2
     */
    tenant: string;
    /**
     * workspace is the workspace identifier.
     *
     * @generated from protobuf field: string workspace = 3
     */
    workspace: string;
    /**
     * nats_msg_id is the NATS message ID for this execution.
     *
     * @generated from protobuf field: string nats_msg_id = 4
     */
    natsMsgId: string;
    /**
     * holder_pid is the Hollywood actor PID requesting the lock.
     *
     * @generated from protobuf field: string holder_pid = 5
     */
    holderPid: string;
    /**
     * ttl_seconds is the lock TTL duration.
     *
     * @generated from protobuf field: int32 ttl_seconds = 6
     */
    ttlSeconds: number;
}
/**
 * ToolExecutionLockAcquireResponse returns lock acquisition result.
 *
 * @generated from protobuf message agency.tool.v1.ToolExecutionLockAcquireResponse
 */
export interface ToolExecutionLockAcquireResponse {
    /**
     * acquired indicates if the lock was successfully acquired.
     *
     * @generated from protobuf field: bool acquired = 1
     */
    acquired: boolean;
    /**
     * lock is the acquired lock (only if acquired is true).
     *
     * @generated from protobuf field: agency.tool.v1.ToolExecutionLock lock = 2
     */
    lock?: ToolExecutionLock;
    /**
     * conflict_holder_pid is the PID holding the lock (if acquired is false).
     *
     * @generated from protobuf field: string conflict_holder_pid = 3
     */
    conflictHolderPid: string;
    /**
     * retry_after_ms is the milliseconds to wait before retrying (if not acquired).
     *
     * @generated from protobuf field: int64 retry_after_ms = 4
     */
    retryAfterMs: bigint;
}
/**
 * ToolExecutionLockReleaseRequest requests lock release.
 *
 * @generated from protobuf message agency.tool.v1.ToolExecutionLockReleaseRequest
 */
export interface ToolExecutionLockReleaseRequest {
    /**
     * lock_key is the KV lock key to release.
     *
     * @generated from protobuf field: string lock_key = 1
     */
    lockKey: string;
    /**
     * holder_pid is the Hollywood actor PID releasing the lock.
     *
     * @generated from protobuf field: string holder_pid = 2
     */
    holderPid: string;
}
/**
 * ToolExecutionLockReleaseResponse confirms lock release.
 *
 * @generated from protobuf message agency.tool.v1.ToolExecutionLockReleaseResponse
 */
export interface ToolExecutionLockReleaseResponse {
    /**
     * released indicates if the lock was successfully released.
     *
     * @generated from protobuf field: bool released = 1
     */
    released: boolean;
    /**
     * released_at is when the lock was released.
     *
     * @generated from protobuf field: google.protobuf.Timestamp released_at = 2
     */
    releasedAt?: Timestamp;
}
/**
 * ExecutionMode defines how a remote tool receives and responds to execution requests.
 *
 * @generated from protobuf enum agency.tool.v1.ExecutionMode
 */
export enum ExecutionMode {
    /**
     * EXECUTION_MODE_UNSPECIFIED is invalid.
     *
     * @generated from protobuf enum value: EXECUTION_MODE_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * EXECUTION_MODE_SYNC — synchronous req/reply via NATS core.
     * Tool subscribes to tool.exec.<tenant>.<workspace>.<tool_name>.
     * Harness calls nc.RequestWithContext(), awaits ToolResult reply.
     *
     * @generated from protobuf enum value: EXECUTION_MODE_SYNC = 1;
     */
    SYNC = 1,
    /**
     * EXECUTION_MODE_ASYNC — asynchronous via JetStream WorkQueue.
     * Tool consumes from tool-requests_<tenant>_<workspace> stream.
     * Publishes ToolResult to tool.response.<tenant>.<workspace>.<session>.<call_id>.
     *
     * @generated from protobuf enum value: EXECUTION_MODE_ASYNC = 2;
     */
    ASYNC = 2
}
/**
 * ErrorClass classifies tool execution errors for retry/recovery policy.
 *
 * @generated from protobuf enum agency.tool.v1.ErrorClass
 */
export enum ErrorClass {
    /**
     * UNSPECIFIED is the zero value and should not be used.
     *
     * @generated from protobuf enum value: ERROR_CLASS_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * NONE indicates successful execution.
     *
     * @generated from protobuf enum value: ERROR_CLASS_ERROR_NONE = 1;
     */
    ERROR_NONE = 1,
    /**
     * TRANSIENT errors should be retried with backoff.
     *
     * @generated from protobuf enum value: ERROR_CLASS_ERROR_TRANSIENT = 2;
     */
    ERROR_TRANSIENT = 2,
    /**
     * PERMANENT errors should fail the session.
     *
     * @generated from protobuf enum value: ERROR_CLASS_ERROR_PERMANENT = 3;
     */
    ERROR_PERMANENT = 3,
    /**
     * DEGRADED errors allow continuing without this tool.
     *
     * @generated from protobuf enum value: ERROR_CLASS_ERROR_DEGRADED = 4;
     */
    ERROR_DEGRADED = 4
}
// @generated message type with reflection information, may provide speed optimized methods
class ToolCallFrequencyConfig$Type extends MessageType<ToolCallFrequencyConfig> {
    constructor() {
        super("agency.tool.v1.ToolCallFrequencyConfig", [
            { no: 1, name: "max_calls_per_minute", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "buf.validate.field": { int32: { lte: 10000, gte: 1 } } } },
            { no: 2, name: "sliding_window_seconds", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "buf.validate.field": { int32: { lte: 3600, gte: 1 } } } },
            { no: 3, name: "burst_allowance", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "buf.validate.field": { int32: { lte: 100, gte: 0 } } } }
        ]);
    }
    create(value?: PartialMessage<ToolCallFrequencyConfig>): ToolCallFrequencyConfig {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.maxCallsPerMinute = 0;
        message.slidingWindowSeconds = 0;
        message.burstAllowance = 0;
        if (value !== undefined)
            reflectionMergePartial<ToolCallFrequencyConfig>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ToolCallFrequencyConfig): ToolCallFrequencyConfig {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 max_calls_per_minute */ 1:
                    message.maxCallsPerMinute = reader.int32();
                    break;
                case /* int32 sliding_window_seconds */ 2:
                    message.slidingWindowSeconds = reader.int32();
                    break;
                case /* int32 burst_allowance */ 3:
                    message.burstAllowance = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ToolCallFrequencyConfig, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int32 max_calls_per_minute = 1; */
        if (message.maxCallsPerMinute !== 0)
            writer.tag(1, WireType.Varint).int32(message.maxCallsPerMinute);
        /* int32 sliding_window_seconds = 2; */
        if (message.slidingWindowSeconds !== 0)
            writer.tag(2, WireType.Varint).int32(message.slidingWindowSeconds);
        /* int32 burst_allowance = 3; */
        if (message.burstAllowance !== 0)
            writer.tag(3, WireType.Varint).int32(message.burstAllowance);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message agency.tool.v1.ToolCallFrequencyConfig
 */
export const ToolCallFrequencyConfig = new ToolCallFrequencyConfig$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ToolDescriptor$Type extends MessageType<ToolDescriptor> {
    constructor() {
        super("agency.tool.v1.ToolDescriptor", [
            { no: 1, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "128", pattern: "^[a-z0-9][a-z0-9_]*[a-z0-9]$" } } } },
            { no: 2, name: "description", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "2048" } } } },
            { no: 3, name: "tags", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { repeated: { maxItems: "20", items: { string: { minLen: "1", maxLen: "64", pattern: "^[a-z0-9][a-z0-9_-]*[a-z0-9]$" } } } } } },
            { no: 4, name: "category", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "64", pattern: "^[a-z0-9][a-z0-9_-]*[a-z0-9]$" } } } },
            { no: 5, name: "input_schema", kind: "message", T: () => Struct, options: { "buf.validate.field": { required: true } } },
            { no: 6, name: "exclusive", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 7, name: "frequency_limit", kind: "message", T: () => ToolCallFrequencyConfig },
            { no: 8, name: "estimated_cost_tokens", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/, options: { "buf.validate.field": { int64: { lte: "1000000", gte: "0" } } } },
            { no: 9, name: "timeout_seconds", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "buf.validate.field": { int32: { lte: 3600, gte: 1 } } } },
            { no: 10, name: "requires_credentials", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 11, name: "version", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { maxLen: "32", pattern: "^([0-9]+\\.[0-9]+\\.[0-9]+)?$" } } } },
            { no: 12, name: "provider", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { maxLen: "128", pattern: "^[a-z0-9][a-z0-9_-]*[a-z0-9]$" } } } },
            { no: 13, name: "credential_key", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { maxLen: "256" } } } },
            { no: 14, name: "embedding", kind: "scalar", repeat: 1 /*RepeatType.PACKED*/, T: 2 /*ScalarType.FLOAT*/, options: { "buf.validate.field": { repeated: { maxItems: "4096" } } } },
            { no: 15, name: "execution_mode", kind: "enum", T: () => ["agency.tool.v1.ExecutionMode", ExecutionMode, "EXECUTION_MODE_"], options: { "buf.validate.field": { enum: { definedOnly: true } } } },
            { no: 16, name: "process_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { maxLen: "128" } } } },
            { no: 17, name: "location", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { maxLen: "128", pattern: "^([a-z0-9][a-z0-9_-]*[a-z0-9])?$" } } } }
        ]);
    }
    create(value?: PartialMessage<ToolDescriptor>): ToolDescriptor {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.name = "";
        message.description = "";
        message.tags = [];
        message.category = "";
        message.exclusive = false;
        message.estimatedCostTokens = 0n;
        message.timeoutSeconds = 0;
        message.requiresCredentials = false;
        message.version = "";
        message.provider = "";
        message.credentialKey = "";
        message.embedding = [];
        message.executionMode = 0;
        message.processId = "";
        message.location = "";
        if (value !== undefined)
            reflectionMergePartial<ToolDescriptor>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ToolDescriptor): ToolDescriptor {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string name */ 1:
                    message.name = reader.string();
                    break;
                case /* string description */ 2:
                    message.description = reader.string();
                    break;
                case /* repeated string tags */ 3:
                    message.tags.push(reader.string());
                    break;
                case /* string category */ 4:
                    message.category = reader.string();
                    break;
                case /* google.protobuf.Struct input_schema */ 5:
                    message.inputSchema = Struct.internalBinaryRead(reader, reader.uint32(), options, message.inputSchema);
                    break;
                case /* bool exclusive */ 6:
                    message.exclusive = reader.bool();
                    break;
                case /* agency.tool.v1.ToolCallFrequencyConfig frequency_limit */ 7:
                    message.frequencyLimit = ToolCallFrequencyConfig.internalBinaryRead(reader, reader.uint32(), options, message.frequencyLimit);
                    break;
                case /* int64 estimated_cost_tokens */ 8:
                    message.estimatedCostTokens = reader.int64().toBigInt();
                    break;
                case /* int32 timeout_seconds */ 9:
                    message.timeoutSeconds = reader.int32();
                    break;
                case /* bool requires_credentials */ 10:
                    message.requiresCredentials = reader.bool();
                    break;
                case /* string version */ 11:
                    message.version = reader.string();
                    break;
                case /* string provider */ 12:
                    message.provider = reader.string();
                    break;
                case /* string credential_key */ 13:
                    message.credentialKey = reader.string();
                    break;
                case /* repeated float embedding */ 14:
                    if (wireType === WireType.LengthDelimited)
                        for (let e = reader.int32() + reader.pos; reader.pos < e;)
                            message.embedding.push(reader.float());
                    else
                        message.embedding.push(reader.float());
                    break;
                case /* agency.tool.v1.ExecutionMode execution_mode */ 15:
                    message.executionMode = reader.int32();
                    break;
                case /* string process_id */ 16:
                    message.processId = reader.string();
                    break;
                case /* string location */ 17:
                    message.location = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ToolDescriptor, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string name = 1; */
        if (message.name !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.name);
        /* string description = 2; */
        if (message.description !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.description);
        /* repeated string tags = 3; */
        for (let i = 0; i < message.tags.length; i++)
            writer.tag(3, WireType.LengthDelimited).string(message.tags[i]);
        /* string category = 4; */
        if (message.category !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.category);
        /* google.protobuf.Struct input_schema = 5; */
        if (message.inputSchema)
            Struct.internalBinaryWrite(message.inputSchema, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* bool exclusive = 6; */
        if (message.exclusive !== false)
            writer.tag(6, WireType.Varint).bool(message.exclusive);
        /* agency.tool.v1.ToolCallFrequencyConfig frequency_limit = 7; */
        if (message.frequencyLimit)
            ToolCallFrequencyConfig.internalBinaryWrite(message.frequencyLimit, writer.tag(7, WireType.LengthDelimited).fork(), options).join();
        /* int64 estimated_cost_tokens = 8; */
        if (message.estimatedCostTokens !== 0n)
            writer.tag(8, WireType.Varint).int64(message.estimatedCostTokens);
        /* int32 timeout_seconds = 9; */
        if (message.timeoutSeconds !== 0)
            writer.tag(9, WireType.Varint).int32(message.timeoutSeconds);
        /* bool requires_credentials = 10; */
        if (message.requiresCredentials !== false)
            writer.tag(10, WireType.Varint).bool(message.requiresCredentials);
        /* string version = 11; */
        if (message.version !== "")
            writer.tag(11, WireType.LengthDelimited).string(message.version);
        /* string provider = 12; */
        if (message.provider !== "")
            writer.tag(12, WireType.LengthDelimited).string(message.provider);
        /* string credential_key = 13; */
        if (message.credentialKey !== "")
            writer.tag(13, WireType.LengthDelimited).string(message.credentialKey);
        /* repeated float embedding = 14; */
        if (message.embedding.length) {
            writer.tag(14, WireType.LengthDelimited).fork();
            for (let i = 0; i < message.embedding.length; i++)
                writer.float(message.embedding[i]);
            writer.join();
        }
        /* agency.tool.v1.ExecutionMode execution_mode = 15; */
        if (message.executionMode !== 0)
            writer.tag(15, WireType.Varint).int32(message.executionMode);
        /* string process_id = 16; */
        if (message.processId !== "")
            writer.tag(16, WireType.LengthDelimited).string(message.processId);
        /* string location = 17; */
        if (message.location !== "")
            writer.tag(17, WireType.LengthDelimited).string(message.location);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message agency.tool.v1.ToolDescriptor
 */
export const ToolDescriptor = new ToolDescriptor$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ToolCall$Type extends MessageType<ToolCall> {
    constructor() {
        super("agency.tool.v1.ToolCall", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "128" } } } },
            { no: 2, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "128", pattern: "^[a-z0-9][a-z0-9_]*[a-z0-9]$" } } } },
            { no: 3, name: "arguments", kind: "message", T: () => Struct, options: { "buf.validate.field": { required: true } } },
            { no: 4, name: "created_at", kind: "message", T: () => Timestamp, options: { "buf.validate.field": { required: true } } },
            { no: 5, name: "session_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "128" } } } },
            { no: 6, name: "turn_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "128" } } } },
            { no: 7, name: "nats_msg_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { maxLen: "256" } } } }
        ]);
    }
    create(value?: PartialMessage<ToolCall>): ToolCall {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.id = "";
        message.name = "";
        message.sessionId = "";
        message.turnId = "";
        message.natsMsgId = "";
        if (value !== undefined)
            reflectionMergePartial<ToolCall>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ToolCall): ToolCall {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id */ 1:
                    message.id = reader.string();
                    break;
                case /* string name */ 2:
                    message.name = reader.string();
                    break;
                case /* google.protobuf.Struct arguments */ 3:
                    message.arguments = Struct.internalBinaryRead(reader, reader.uint32(), options, message.arguments);
                    break;
                case /* google.protobuf.Timestamp created_at */ 4:
                    message.createdAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.createdAt);
                    break;
                case /* string session_id */ 5:
                    message.sessionId = reader.string();
                    break;
                case /* string turn_id */ 6:
                    message.turnId = reader.string();
                    break;
                case /* string nats_msg_id */ 7:
                    message.natsMsgId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ToolCall, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string id = 1; */
        if (message.id !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.id);
        /* string name = 2; */
        if (message.name !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.name);
        /* google.protobuf.Struct arguments = 3; */
        if (message.arguments)
            Struct.internalBinaryWrite(message.arguments, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp created_at = 4; */
        if (message.createdAt)
            Timestamp.internalBinaryWrite(message.createdAt, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* string session_id = 5; */
        if (message.sessionId !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.sessionId);
        /* string turn_id = 6; */
        if (message.turnId !== "")
            writer.tag(6, WireType.LengthDelimited).string(message.turnId);
        /* string nats_msg_id = 7; */
        if (message.natsMsgId !== "")
            writer.tag(7, WireType.LengthDelimited).string(message.natsMsgId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message agency.tool.v1.ToolCall
 */
export const ToolCall = new ToolCall$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ToolCredentials$Type extends MessageType<ToolCredentials> {
    constructor() {
        super("agency.tool.v1.ToolCredentials", [
            { no: 1, name: "secrets", kind: "map", K: 9 /*ScalarType.STRING*/, V: { kind: "scalar", T: 9 /*ScalarType.STRING*/ }, options: { "buf.validate.field": { map: { maxPairs: "20", keys: { string: { minLen: "1", maxLen: "128", pattern: "^[a-z0-9][a-z0-9_]*[a-z0-9]$" } }, values: { string: { minLen: "1", maxLen: "4096" } } } } } },
            { no: 2, name: "metadata", kind: "map", K: 9 /*ScalarType.STRING*/, V: { kind: "scalar", T: 9 /*ScalarType.STRING*/ }, options: { "buf.validate.field": { map: { maxPairs: "20", keys: { string: { minLen: "1", maxLen: "128" } }, values: { string: { maxLen: "2048" } } } } } },
            { no: 3, name: "expires_at", kind: "message", T: () => Timestamp }
        ]);
    }
    create(value?: PartialMessage<ToolCredentials>): ToolCredentials {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.secrets = {};
        message.metadata = {};
        if (value !== undefined)
            reflectionMergePartial<ToolCredentials>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ToolCredentials): ToolCredentials {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* map<string, string> secrets */ 1:
                    this.binaryReadMap1(message.secrets, reader, options);
                    break;
                case /* map<string, string> metadata */ 2:
                    this.binaryReadMap2(message.metadata, reader, options);
                    break;
                case /* google.protobuf.Timestamp expires_at */ 3:
                    message.expiresAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.expiresAt);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    private binaryReadMap1(map: ToolCredentials["secrets"], reader: IBinaryReader, options: BinaryReadOptions): void {
        let len = reader.uint32(), end = reader.pos + len, key: keyof ToolCredentials["secrets"] | undefined, val: ToolCredentials["secrets"][any] | undefined;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case 1:
                    key = reader.string();
                    break;
                case 2:
                    val = reader.string();
                    break;
                default: throw new globalThis.Error("unknown map entry field for agency.tool.v1.ToolCredentials.secrets");
            }
        }
        map[key ?? ""] = val ?? "";
    }
    private binaryReadMap2(map: ToolCredentials["metadata"], reader: IBinaryReader, options: BinaryReadOptions): void {
        let len = reader.uint32(), end = reader.pos + len, key: keyof ToolCredentials["metadata"] | undefined, val: ToolCredentials["metadata"][any] | undefined;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case 1:
                    key = reader.string();
                    break;
                case 2:
                    val = reader.string();
                    break;
                default: throw new globalThis.Error("unknown map entry field for agency.tool.v1.ToolCredentials.metadata");
            }
        }
        map[key ?? ""] = val ?? "";
    }
    internalBinaryWrite(message: ToolCredentials, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* map<string, string> secrets = 1; */
        for (let k of globalThis.Object.keys(message.secrets))
            writer.tag(1, WireType.LengthDelimited).fork().tag(1, WireType.LengthDelimited).string(k).tag(2, WireType.LengthDelimited).string(message.secrets[k]).join();
        /* map<string, string> metadata = 2; */
        for (let k of globalThis.Object.keys(message.metadata))
            writer.tag(2, WireType.LengthDelimited).fork().tag(1, WireType.LengthDelimited).string(k).tag(2, WireType.LengthDelimited).string(message.metadata[k]).join();
        /* google.protobuf.Timestamp expires_at = 3; */
        if (message.expiresAt)
            Timestamp.internalBinaryWrite(message.expiresAt, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message agency.tool.v1.ToolCredentials
 */
export const ToolCredentials = new ToolCredentials$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ToolExecutionEnvelope$Type extends MessageType<ToolExecutionEnvelope> {
    constructor() {
        super("agency.tool.v1.ToolExecutionEnvelope", [
            { no: 1, name: "call", kind: "message", T: () => ToolCall, options: { "buf.validate.field": { required: true } } },
            { no: 2, name: "credentials", kind: "message", T: () => ToolCredentials },
            { no: 3, name: "tenant", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "64", pattern: "^[a-z0-9][a-z0-9-]*[a-z0-9]$" } } } },
            { no: 4, name: "workspace", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "64", pattern: "^[a-z0-9][a-z0-9-]*[a-z0-9]$" } } } },
            { no: 5, name: "trace_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { len: "32", pattern: "^[0-9a-f]{32}$" } } } }
        ]);
    }
    create(value?: PartialMessage<ToolExecutionEnvelope>): ToolExecutionEnvelope {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.tenant = "";
        message.workspace = "";
        message.traceId = "";
        if (value !== undefined)
            reflectionMergePartial<ToolExecutionEnvelope>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ToolExecutionEnvelope): ToolExecutionEnvelope {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* agency.tool.v1.ToolCall call */ 1:
                    message.call = ToolCall.internalBinaryRead(reader, reader.uint32(), options, message.call);
                    break;
                case /* agency.tool.v1.ToolCredentials credentials */ 2:
                    message.credentials = ToolCredentials.internalBinaryRead(reader, reader.uint32(), options, message.credentials);
                    break;
                case /* string tenant */ 3:
                    message.tenant = reader.string();
                    break;
                case /* string workspace */ 4:
                    message.workspace = reader.string();
                    break;
                case /* string trace_id */ 5:
                    message.traceId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ToolExecutionEnvelope, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* agency.tool.v1.ToolCall call = 1; */
        if (message.call)
            ToolCall.internalBinaryWrite(message.call, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* agency.tool.v1.ToolCredentials credentials = 2; */
        if (message.credentials)
            ToolCredentials.internalBinaryWrite(message.credentials, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* string tenant = 3; */
        if (message.tenant !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.tenant);
        /* string workspace = 4; */
        if (message.workspace !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.workspace);
        /* string trace_id = 5; */
        if (message.traceId !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.traceId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message agency.tool.v1.ToolExecutionEnvelope
 */
export const ToolExecutionEnvelope = new ToolExecutionEnvelope$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ToolPartialResult$Type extends MessageType<ToolPartialResult> {
    constructor() {
        super("agency.tool.v1.ToolPartialResult", [
            { no: 1, name: "tenant", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "64", pattern: "^[a-z0-9][a-z0-9-]*[a-z0-9]$" } } } },
            { no: 2, name: "workspace", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "64", pattern: "^[a-z0-9][a-z0-9-]*[a-z0-9]$" } } } },
            { no: 3, name: "session_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "128", pattern: "^[a-z0-9][a-z0-9-]*[a-z0-9]$" } } } },
            { no: 4, name: "tool_call_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "128" } } } },
            { no: 5, name: "delta", kind: "message", T: () => Struct, options: { "buf.validate.field": { required: true } } },
            { no: 6, name: "accumulated", kind: "message", T: () => Struct },
            { no: 7, name: "timestamp", kind: "message", T: () => Timestamp, options: { "buf.validate.field": { required: true } } }
        ]);
    }
    create(value?: PartialMessage<ToolPartialResult>): ToolPartialResult {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.tenant = "";
        message.workspace = "";
        message.sessionId = "";
        message.toolCallId = "";
        if (value !== undefined)
            reflectionMergePartial<ToolPartialResult>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ToolPartialResult): ToolPartialResult {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string tenant */ 1:
                    message.tenant = reader.string();
                    break;
                case /* string workspace */ 2:
                    message.workspace = reader.string();
                    break;
                case /* string session_id */ 3:
                    message.sessionId = reader.string();
                    break;
                case /* string tool_call_id */ 4:
                    message.toolCallId = reader.string();
                    break;
                case /* google.protobuf.Struct delta */ 5:
                    message.delta = Struct.internalBinaryRead(reader, reader.uint32(), options, message.delta);
                    break;
                case /* google.protobuf.Struct accumulated */ 6:
                    message.accumulated = Struct.internalBinaryRead(reader, reader.uint32(), options, message.accumulated);
                    break;
                case /* google.protobuf.Timestamp timestamp */ 7:
                    message.timestamp = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.timestamp);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ToolPartialResult, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string tenant = 1; */
        if (message.tenant !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.tenant);
        /* string workspace = 2; */
        if (message.workspace !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.workspace);
        /* string session_id = 3; */
        if (message.sessionId !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.sessionId);
        /* string tool_call_id = 4; */
        if (message.toolCallId !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.toolCallId);
        /* google.protobuf.Struct delta = 5; */
        if (message.delta)
            Struct.internalBinaryWrite(message.delta, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Struct accumulated = 6; */
        if (message.accumulated)
            Struct.internalBinaryWrite(message.accumulated, writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp timestamp = 7; */
        if (message.timestamp)
            Timestamp.internalBinaryWrite(message.timestamp, writer.tag(7, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message agency.tool.v1.ToolPartialResult
 */
export const ToolPartialResult = new ToolPartialResult$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ToolResult$Type extends MessageType<ToolResult> {
    constructor() {
        super("agency.tool.v1.ToolResult", [
            { no: 1, name: "tool_call_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "128" } } } },
            { no: 2, name: "plaintext", kind: "message", oneof: "payload", T: () => Struct },
            { no: 3, name: "age_ciphertext", kind: "scalar", oneof: "payload", T: 12 /*ScalarType.BYTES*/, options: { "buf.validate.field": { bytes: { maxLen: "10485760" } } } },
            { no: 10, name: "binary_data", kind: "scalar", oneof: "payload", T: 12 /*ScalarType.BYTES*/, options: { "buf.validate.field": { bytes: { maxLen: "10485760" } } } },
            { no: 11, name: "object_store_ref", kind: "scalar", oneof: "payload", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { maxLen: "512" } } } },
            { no: 4, name: "recipient_pubkey_fingerprint", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { pattern: "^([0-9a-f]{64})?$" } } } },
            { no: 5, name: "is_error", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 6, name: "error_message", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { maxLen: "4096" } } } },
            { no: 7, name: "error_class", kind: "enum", T: () => ["agency.tool.v1.ErrorClass", ErrorClass, "ERROR_CLASS_"], options: { "buf.validate.field": { enum: { definedOnly: true } } } },
            { no: 8, name: "completed_at", kind: "message", T: () => Timestamp, options: { "buf.validate.field": { required: true } } },
            { no: 9, name: "execution_time_ms", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/, options: { "buf.validate.field": { int64: { gte: "0" } } } },
            { no: 12, name: "tokens_consumed", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/, options: { "buf.validate.field": { int64: { gte: "0" } } } },
            { no: 13, name: "tool_name", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { maxLen: "128", pattern: "^([a-z0-9][a-z0-9_]*[a-z0-9])?$" } } } },
            { no: 14, name: "location", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { maxLen: "128", pattern: "^([a-z0-9][a-z0-9_-]*[a-z0-9])?$" } } } }
        ]);
    }
    create(value?: PartialMessage<ToolResult>): ToolResult {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.toolCallId = "";
        message.payload = { oneofKind: undefined };
        message.recipientPubkeyFingerprint = "";
        message.isError = false;
        message.errorMessage = "";
        message.errorClass = 0;
        message.executionTimeMs = 0n;
        message.tokensConsumed = 0n;
        message.toolName = "";
        message.location = "";
        if (value !== undefined)
            reflectionMergePartial<ToolResult>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ToolResult): ToolResult {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string tool_call_id */ 1:
                    message.toolCallId = reader.string();
                    break;
                case /* google.protobuf.Struct plaintext */ 2:
                    message.payload = {
                        oneofKind: "plaintext",
                        plaintext: Struct.internalBinaryRead(reader, reader.uint32(), options, (message.payload as any).plaintext)
                    };
                    break;
                case /* bytes age_ciphertext */ 3:
                    message.payload = {
                        oneofKind: "ageCiphertext",
                        ageCiphertext: reader.bytes()
                    };
                    break;
                case /* bytes binary_data */ 10:
                    message.payload = {
                        oneofKind: "binaryData",
                        binaryData: reader.bytes()
                    };
                    break;
                case /* string object_store_ref */ 11:
                    message.payload = {
                        oneofKind: "objectStoreRef",
                        objectStoreRef: reader.string()
                    };
                    break;
                case /* string recipient_pubkey_fingerprint */ 4:
                    message.recipientPubkeyFingerprint = reader.string();
                    break;
                case /* bool is_error */ 5:
                    message.isError = reader.bool();
                    break;
                case /* string error_message */ 6:
                    message.errorMessage = reader.string();
                    break;
                case /* agency.tool.v1.ErrorClass error_class */ 7:
                    message.errorClass = reader.int32();
                    break;
                case /* google.protobuf.Timestamp completed_at */ 8:
                    message.completedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.completedAt);
                    break;
                case /* int64 execution_time_ms */ 9:
                    message.executionTimeMs = reader.int64().toBigInt();
                    break;
                case /* int64 tokens_consumed */ 12:
                    message.tokensConsumed = reader.int64().toBigInt();
                    break;
                case /* string tool_name */ 13:
                    message.toolName = reader.string();
                    break;
                case /* string location */ 14:
                    message.location = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ToolResult, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string tool_call_id = 1; */
        if (message.toolCallId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.toolCallId);
        /* google.protobuf.Struct plaintext = 2; */
        if (message.payload.oneofKind === "plaintext")
            Struct.internalBinaryWrite(message.payload.plaintext, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* bytes age_ciphertext = 3; */
        if (message.payload.oneofKind === "ageCiphertext")
            writer.tag(3, WireType.LengthDelimited).bytes(message.payload.ageCiphertext);
        /* string recipient_pubkey_fingerprint = 4; */
        if (message.recipientPubkeyFingerprint !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.recipientPubkeyFingerprint);
        /* bool is_error = 5; */
        if (message.isError !== false)
            writer.tag(5, WireType.Varint).bool(message.isError);
        /* string error_message = 6; */
        if (message.errorMessage !== "")
            writer.tag(6, WireType.LengthDelimited).string(message.errorMessage);
        /* agency.tool.v1.ErrorClass error_class = 7; */
        if (message.errorClass !== 0)
            writer.tag(7, WireType.Varint).int32(message.errorClass);
        /* google.protobuf.Timestamp completed_at = 8; */
        if (message.completedAt)
            Timestamp.internalBinaryWrite(message.completedAt, writer.tag(8, WireType.LengthDelimited).fork(), options).join();
        /* int64 execution_time_ms = 9; */
        if (message.executionTimeMs !== 0n)
            writer.tag(9, WireType.Varint).int64(message.executionTimeMs);
        /* bytes binary_data = 10; */
        if (message.payload.oneofKind === "binaryData")
            writer.tag(10, WireType.LengthDelimited).bytes(message.payload.binaryData);
        /* string object_store_ref = 11; */
        if (message.payload.oneofKind === "objectStoreRef")
            writer.tag(11, WireType.LengthDelimited).string(message.payload.objectStoreRef);
        /* int64 tokens_consumed = 12; */
        if (message.tokensConsumed !== 0n)
            writer.tag(12, WireType.Varint).int64(message.tokensConsumed);
        /* string tool_name = 13; */
        if (message.toolName !== "")
            writer.tag(13, WireType.LengthDelimited).string(message.toolName);
        /* string location = 14; */
        if (message.location !== "")
            writer.tag(14, WireType.LengthDelimited).string(message.location);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message agency.tool.v1.ToolResult
 */
export const ToolResult = new ToolResult$Type();
// @generated message type with reflection information, may provide speed optimized methods
class MatchRequest$Type extends MessageType<MatchRequest> {
    constructor() {
        super("agency.tool.v1.MatchRequest", [
            { no: 1, name: "query", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "2048" } } } },
            { no: 2, name: "tags", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { repeated: { maxItems: "20", items: { string: { minLen: "1", maxLen: "64" } } } } } },
            { no: 3, name: "categories", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { repeated: { maxItems: "10", items: { string: { minLen: "1", maxLen: "64" } } } } } },
            { no: 4, name: "top_k", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "buf.validate.field": { int32: { lte: 100, gte: 1 } } } },
            { no: 5, name: "min_relevance_score", kind: "scalar", T: 2 /*ScalarType.FLOAT*/, options: { "buf.validate.field": { float: { lte: 1, gte: 0 } } } },
            { no: 6, name: "tenant", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "64", pattern: "^[a-z0-9][a-z0-9-]*[a-z0-9]$" } } } },
            { no: 7, name: "workspace", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "64", pattern: "^[a-z0-9][a-z0-9-]*[a-z0-9]$" } } } }
        ]);
    }
    create(value?: PartialMessage<MatchRequest>): MatchRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.query = "";
        message.tags = [];
        message.categories = [];
        message.topK = 0;
        message.minRelevanceScore = 0;
        message.tenant = "";
        message.workspace = "";
        if (value !== undefined)
            reflectionMergePartial<MatchRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: MatchRequest): MatchRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string query */ 1:
                    message.query = reader.string();
                    break;
                case /* repeated string tags */ 2:
                    message.tags.push(reader.string());
                    break;
                case /* repeated string categories */ 3:
                    message.categories.push(reader.string());
                    break;
                case /* int32 top_k */ 4:
                    message.topK = reader.int32();
                    break;
                case /* float min_relevance_score */ 5:
                    message.minRelevanceScore = reader.float();
                    break;
                case /* string tenant */ 6:
                    message.tenant = reader.string();
                    break;
                case /* string workspace */ 7:
                    message.workspace = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: MatchRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string query = 1; */
        if (message.query !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.query);
        /* repeated string tags = 2; */
        for (let i = 0; i < message.tags.length; i++)
            writer.tag(2, WireType.LengthDelimited).string(message.tags[i]);
        /* repeated string categories = 3; */
        for (let i = 0; i < message.categories.length; i++)
            writer.tag(3, WireType.LengthDelimited).string(message.categories[i]);
        /* int32 top_k = 4; */
        if (message.topK !== 0)
            writer.tag(4, WireType.Varint).int32(message.topK);
        /* float min_relevance_score = 5; */
        if (message.minRelevanceScore !== 0)
            writer.tag(5, WireType.Bit32).float(message.minRelevanceScore);
        /* string tenant = 6; */
        if (message.tenant !== "")
            writer.tag(6, WireType.LengthDelimited).string(message.tenant);
        /* string workspace = 7; */
        if (message.workspace !== "")
            writer.tag(7, WireType.LengthDelimited).string(message.workspace);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message agency.tool.v1.MatchRequest
 */
export const MatchRequest = new MatchRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class MatchResponse$Type extends MessageType<MatchResponse> {
    constructor() {
        super("agency.tool.v1.MatchResponse", [
            { no: 1, name: "tools", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => ToolDescriptor, options: { "buf.validate.field": { repeated: { maxItems: "100" } } } },
            { no: 2, name: "relevance_scores", kind: "scalar", repeat: 1 /*RepeatType.PACKED*/, T: 2 /*ScalarType.FLOAT*/, options: { "buf.validate.field": { repeated: { maxItems: "100" } } } },
            { no: 3, name: "total_matches", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "buf.validate.field": { int32: { gte: 0 } } } }
        ]);
    }
    create(value?: PartialMessage<MatchResponse>): MatchResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.tools = [];
        message.relevanceScores = [];
        message.totalMatches = 0;
        if (value !== undefined)
            reflectionMergePartial<MatchResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: MatchResponse): MatchResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated agency.tool.v1.ToolDescriptor tools */ 1:
                    message.tools.push(ToolDescriptor.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated float relevance_scores */ 2:
                    if (wireType === WireType.LengthDelimited)
                        for (let e = reader.int32() + reader.pos; reader.pos < e;)
                            message.relevanceScores.push(reader.float());
                    else
                        message.relevanceScores.push(reader.float());
                    break;
                case /* int32 total_matches */ 3:
                    message.totalMatches = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: MatchResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated agency.tool.v1.ToolDescriptor tools = 1; */
        for (let i = 0; i < message.tools.length; i++)
            ToolDescriptor.internalBinaryWrite(message.tools[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* repeated float relevance_scores = 2; */
        if (message.relevanceScores.length) {
            writer.tag(2, WireType.LengthDelimited).fork();
            for (let i = 0; i < message.relevanceScores.length; i++)
                writer.float(message.relevanceScores[i]);
            writer.join();
        }
        /* int32 total_matches = 3; */
        if (message.totalMatches !== 0)
            writer.tag(3, WireType.Varint).int32(message.totalMatches);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message agency.tool.v1.MatchResponse
 */
export const MatchResponse = new MatchResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ToolDecision$Type extends MessageType<ToolDecision> {
    constructor() {
        super("agency.tool.v1.ToolDecision", [
            { no: 1, name: "approved", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 2, name: "reason", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { maxLen: "1024" } } } },
            { no: 3, name: "modified_arguments", kind: "message", T: () => Struct },
            { no: 4, name: "hook_name", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { maxLen: "128", pattern: "^[a-z0-9][a-z0-9_-]*[a-z0-9]$" } } } },
            { no: 5, name: "decided_at", kind: "message", T: () => Timestamp, options: { "buf.validate.field": { required: true } } }
        ]);
    }
    create(value?: PartialMessage<ToolDecision>): ToolDecision {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.approved = false;
        message.reason = "";
        message.hookName = "";
        if (value !== undefined)
            reflectionMergePartial<ToolDecision>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ToolDecision): ToolDecision {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool approved */ 1:
                    message.approved = reader.bool();
                    break;
                case /* string reason */ 2:
                    message.reason = reader.string();
                    break;
                case /* google.protobuf.Struct modified_arguments */ 3:
                    message.modifiedArguments = Struct.internalBinaryRead(reader, reader.uint32(), options, message.modifiedArguments);
                    break;
                case /* string hook_name */ 4:
                    message.hookName = reader.string();
                    break;
                case /* google.protobuf.Timestamp decided_at */ 5:
                    message.decidedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.decidedAt);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ToolDecision, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* bool approved = 1; */
        if (message.approved !== false)
            writer.tag(1, WireType.Varint).bool(message.approved);
        /* string reason = 2; */
        if (message.reason !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.reason);
        /* google.protobuf.Struct modified_arguments = 3; */
        if (message.modifiedArguments)
            Struct.internalBinaryWrite(message.modifiedArguments, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* string hook_name = 4; */
        if (message.hookName !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.hookName);
        /* google.protobuf.Timestamp decided_at = 5; */
        if (message.decidedAt)
            Timestamp.internalBinaryWrite(message.decidedAt, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message agency.tool.v1.ToolDecision
 */
export const ToolDecision = new ToolDecision$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ToolExecutionLock$Type extends MessageType<ToolExecutionLock> {
    constructor() {
        super("agency.tool.v1.ToolExecutionLock", [
            { no: 1, name: "lock_key", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "512", pattern: "^tool-execution-lock\\.[a-z0-9][a-z0-9-]*\\.[a-z0-9][a-z0-9-]*\\.[a-z0-9][a-z0-9._-]*$" } } } },
            { no: 2, name: "tool_name", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "128", pattern: "^[a-z0-9][a-z0-9_]*[a-z0-9]$" } } } },
            { no: 3, name: "tenant", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "64", pattern: "^[a-z0-9][a-z0-9-]*[a-z0-9]$" } } } },
            { no: 4, name: "workspace", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "64", pattern: "^[a-z0-9][a-z0-9-]*[a-z0-9]$" } } } },
            { no: 5, name: "nats_msg_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "256" } } } },
            { no: 6, name: "holder_pid", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "256" } } } },
            { no: 7, name: "acquired_at", kind: "message", T: () => Timestamp, options: { "buf.validate.field": { required: true } } },
            { no: 8, name: "expires_at", kind: "message", T: () => Timestamp, options: { "buf.validate.field": { required: true } } }
        ]);
    }
    create(value?: PartialMessage<ToolExecutionLock>): ToolExecutionLock {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.lockKey = "";
        message.toolName = "";
        message.tenant = "";
        message.workspace = "";
        message.natsMsgId = "";
        message.holderPid = "";
        if (value !== undefined)
            reflectionMergePartial<ToolExecutionLock>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ToolExecutionLock): ToolExecutionLock {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string lock_key */ 1:
                    message.lockKey = reader.string();
                    break;
                case /* string tool_name */ 2:
                    message.toolName = reader.string();
                    break;
                case /* string tenant */ 3:
                    message.tenant = reader.string();
                    break;
                case /* string workspace */ 4:
                    message.workspace = reader.string();
                    break;
                case /* string nats_msg_id */ 5:
                    message.natsMsgId = reader.string();
                    break;
                case /* string holder_pid */ 6:
                    message.holderPid = reader.string();
                    break;
                case /* google.protobuf.Timestamp acquired_at */ 7:
                    message.acquiredAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.acquiredAt);
                    break;
                case /* google.protobuf.Timestamp expires_at */ 8:
                    message.expiresAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.expiresAt);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ToolExecutionLock, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string lock_key = 1; */
        if (message.lockKey !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.lockKey);
        /* string tool_name = 2; */
        if (message.toolName !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.toolName);
        /* string tenant = 3; */
        if (message.tenant !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.tenant);
        /* string workspace = 4; */
        if (message.workspace !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.workspace);
        /* string nats_msg_id = 5; */
        if (message.natsMsgId !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.natsMsgId);
        /* string holder_pid = 6; */
        if (message.holderPid !== "")
            writer.tag(6, WireType.LengthDelimited).string(message.holderPid);
        /* google.protobuf.Timestamp acquired_at = 7; */
        if (message.acquiredAt)
            Timestamp.internalBinaryWrite(message.acquiredAt, writer.tag(7, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp expires_at = 8; */
        if (message.expiresAt)
            Timestamp.internalBinaryWrite(message.expiresAt, writer.tag(8, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message agency.tool.v1.ToolExecutionLock
 */
export const ToolExecutionLock = new ToolExecutionLock$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ToolExecutionLockAcquireRequest$Type extends MessageType<ToolExecutionLockAcquireRequest> {
    constructor() {
        super("agency.tool.v1.ToolExecutionLockAcquireRequest", [
            { no: 1, name: "tool_name", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "128", pattern: "^[a-z0-9][a-z0-9_]*[a-z0-9]$" } } } },
            { no: 2, name: "tenant", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "64", pattern: "^[a-z0-9][a-z0-9-]*[a-z0-9]$" } } } },
            { no: 3, name: "workspace", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "64", pattern: "^[a-z0-9][a-z0-9-]*[a-z0-9]$" } } } },
            { no: 4, name: "nats_msg_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "256" } } } },
            { no: 5, name: "holder_pid", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "256" } } } },
            { no: 6, name: "ttl_seconds", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "buf.validate.field": { int32: { lte: 3600, gte: 1 } } } }
        ]);
    }
    create(value?: PartialMessage<ToolExecutionLockAcquireRequest>): ToolExecutionLockAcquireRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.toolName = "";
        message.tenant = "";
        message.workspace = "";
        message.natsMsgId = "";
        message.holderPid = "";
        message.ttlSeconds = 0;
        if (value !== undefined)
            reflectionMergePartial<ToolExecutionLockAcquireRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ToolExecutionLockAcquireRequest): ToolExecutionLockAcquireRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string tool_name */ 1:
                    message.toolName = reader.string();
                    break;
                case /* string tenant */ 2:
                    message.tenant = reader.string();
                    break;
                case /* string workspace */ 3:
                    message.workspace = reader.string();
                    break;
                case /* string nats_msg_id */ 4:
                    message.natsMsgId = reader.string();
                    break;
                case /* string holder_pid */ 5:
                    message.holderPid = reader.string();
                    break;
                case /* int32 ttl_seconds */ 6:
                    message.ttlSeconds = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ToolExecutionLockAcquireRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string tool_name = 1; */
        if (message.toolName !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.toolName);
        /* string tenant = 2; */
        if (message.tenant !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.tenant);
        /* string workspace = 3; */
        if (message.workspace !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.workspace);
        /* string nats_msg_id = 4; */
        if (message.natsMsgId !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.natsMsgId);
        /* string holder_pid = 5; */
        if (message.holderPid !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.holderPid);
        /* int32 ttl_seconds = 6; */
        if (message.ttlSeconds !== 0)
            writer.tag(6, WireType.Varint).int32(message.ttlSeconds);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message agency.tool.v1.ToolExecutionLockAcquireRequest
 */
export const ToolExecutionLockAcquireRequest = new ToolExecutionLockAcquireRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ToolExecutionLockAcquireResponse$Type extends MessageType<ToolExecutionLockAcquireResponse> {
    constructor() {
        super("agency.tool.v1.ToolExecutionLockAcquireResponse", [
            { no: 1, name: "acquired", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 2, name: "lock", kind: "message", T: () => ToolExecutionLock },
            { no: 3, name: "conflict_holder_pid", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { maxLen: "256" } } } },
            { no: 4, name: "retry_after_ms", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/, options: { "buf.validate.field": { int64: { gte: "0" } } } }
        ]);
    }
    create(value?: PartialMessage<ToolExecutionLockAcquireResponse>): ToolExecutionLockAcquireResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.acquired = false;
        message.conflictHolderPid = "";
        message.retryAfterMs = 0n;
        if (value !== undefined)
            reflectionMergePartial<ToolExecutionLockAcquireResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ToolExecutionLockAcquireResponse): ToolExecutionLockAcquireResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool acquired */ 1:
                    message.acquired = reader.bool();
                    break;
                case /* agency.tool.v1.ToolExecutionLock lock */ 2:
                    message.lock = ToolExecutionLock.internalBinaryRead(reader, reader.uint32(), options, message.lock);
                    break;
                case /* string conflict_holder_pid */ 3:
                    message.conflictHolderPid = reader.string();
                    break;
                case /* int64 retry_after_ms */ 4:
                    message.retryAfterMs = reader.int64().toBigInt();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ToolExecutionLockAcquireResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* bool acquired = 1; */
        if (message.acquired !== false)
            writer.tag(1, WireType.Varint).bool(message.acquired);
        /* agency.tool.v1.ToolExecutionLock lock = 2; */
        if (message.lock)
            ToolExecutionLock.internalBinaryWrite(message.lock, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* string conflict_holder_pid = 3; */
        if (message.conflictHolderPid !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.conflictHolderPid);
        /* int64 retry_after_ms = 4; */
        if (message.retryAfterMs !== 0n)
            writer.tag(4, WireType.Varint).int64(message.retryAfterMs);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message agency.tool.v1.ToolExecutionLockAcquireResponse
 */
export const ToolExecutionLockAcquireResponse = new ToolExecutionLockAcquireResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ToolExecutionLockReleaseRequest$Type extends MessageType<ToolExecutionLockReleaseRequest> {
    constructor() {
        super("agency.tool.v1.ToolExecutionLockReleaseRequest", [
            { no: 1, name: "lock_key", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "512" } } } },
            { no: 2, name: "holder_pid", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "256" } } } }
        ]);
    }
    create(value?: PartialMessage<ToolExecutionLockReleaseRequest>): ToolExecutionLockReleaseRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.lockKey = "";
        message.holderPid = "";
        if (value !== undefined)
            reflectionMergePartial<ToolExecutionLockReleaseRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ToolExecutionLockReleaseRequest): ToolExecutionLockReleaseRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string lock_key */ 1:
                    message.lockKey = reader.string();
                    break;
                case /* string holder_pid */ 2:
                    message.holderPid = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ToolExecutionLockReleaseRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string lock_key = 1; */
        if (message.lockKey !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.lockKey);
        /* string holder_pid = 2; */
        if (message.holderPid !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.holderPid);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message agency.tool.v1.ToolExecutionLockReleaseRequest
 */
export const ToolExecutionLockReleaseRequest = new ToolExecutionLockReleaseRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ToolExecutionLockReleaseResponse$Type extends MessageType<ToolExecutionLockReleaseResponse> {
    constructor() {
        super("agency.tool.v1.ToolExecutionLockReleaseResponse", [
            { no: 1, name: "released", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 2, name: "released_at", kind: "message", T: () => Timestamp, options: { "buf.validate.field": { required: true } } }
        ]);
    }
    create(value?: PartialMessage<ToolExecutionLockReleaseResponse>): ToolExecutionLockReleaseResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.released = false;
        if (value !== undefined)
            reflectionMergePartial<ToolExecutionLockReleaseResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ToolExecutionLockReleaseResponse): ToolExecutionLockReleaseResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool released */ 1:
                    message.released = reader.bool();
                    break;
                case /* google.protobuf.Timestamp released_at */ 2:
                    message.releasedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.releasedAt);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ToolExecutionLockReleaseResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* bool released = 1; */
        if (message.released !== false)
            writer.tag(1, WireType.Varint).bool(message.released);
        /* google.protobuf.Timestamp released_at = 2; */
        if (message.releasedAt)
            Timestamp.internalBinaryWrite(message.releasedAt, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message agency.tool.v1.ToolExecutionLockReleaseResponse
 */
export const ToolExecutionLockReleaseResponse = new ToolExecutionLockReleaseResponse$Type();
/**
 * @generated ServiceType for protobuf service agency.tool.v1.ToolMatcherService
 */
export const ToolMatcherService = new ServiceType("agency.tool.v1.ToolMatcherService", [
    { name: "Match", options: {}, I: MatchRequest, O: MatchResponse }
]);
